import { createActionGroup, props } from '@ngrx/store';
import { Role, PaginatedResult } from '@niko-crm/ui';

export const RoleActions = createActionGroup({
  source: 'Roles',
  events: {
    'Load Roles': props<{ page: number; limit: number }>(),
    'Load Roles Success': props<{ result: PaginatedResult<Role> }>(),
    'Load Roles Failure': props<{ error: string }>(),
    'Create Role': props<{ payload: { name: string; tenantId?: string; description?: string } }>(),
    'Create Role Success': props<{ role: Role }>(),
    'Create Role Failure': props<{ error: string }>(),
    'Update Role': props<{ id: string; payload: { name: string; tenantId?: string; description?: string } }>(),
    'Update Role Success': props<{ role: Role }>(),
    'Update Role Failure': props<{ error: string }>(),
    'Clone Role': props<{ sourceId: string; tenantId: string }>(),
    'Clone Role Success': props<{ role: Role }>(),
    'Clone Role Failure': props<{ error: string }>(),
  },
});
